module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Avietchii/Tokyo_Avietchii_MRI_RCP85_Mid.png";